module.exports = __webpack_public_path__ + "img/part9-7.8776a795.png";